export const summaryRows: Array<[string, string]> = [
  ['9 tomos premium', 'Fundamentos, mediciones, planimetría, altimetría, GNSS, QGIS, drones, topografía aplicada y planificación 2026'],
  ['5 bonos estratégicos', 'Actividades, evaluaciones, problemas resueltos, guía visual de instrumentos y proyectos integradores'],
  ['150 actividades y prácticas', 'Organizadas por nivel de dificultad, para aula y campo'],
  ['100 problemas resueltos', 'Distancias, escalas, coordenadas, ángulos, pendientes, poligonales, superficies y volúmenes'],
  ['60 instrumentos de evaluación', 'Diagnósticos, trabajos prácticos, rúbricas y listas de cotejo'],
  ['30 proyectos integradores', 'Contextualizados en obras, caminos, minería, agricultura y territorio'],
  ['Planificación anual 2026', 'Secuencias didácticas y organización progresiva de contenidos'],
  ['Prácticas de campo estructuradas', 'Paso a paso, incluso trabajando con recursos limitados'],
  ['Formato PDF editable', 'Personalizable con tu nombre, institución y contexto local'],
  ['Válido para toda Latinoamérica', 'Con orientaciones para adaptar normativa local'],
  ['Acceso inmediato', 'Por correo electrónico, sin esperas ni trámites'],
  ['Pago en USD', 'Con conversión automática a tu moneda local'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
